// https://stackoverflow.com/a/12900504/8242972
// 获取扩展名
function getExtension (path) {
  const cleanPath = path.split(/[?#]/)[0]
  const basename = cleanPath.split(/[\\/]/).pop()
  const pos = basename.lastIndexOf('.')
  if (basename === '' || pos < 1) return ''
  return basename.slice(pos + 1).toLowerCase()
}

function normalizeImageSrc (cdn, src) {
  if (/^(https?:)?\/\//.test(src)) return src
  const cdnHost = cdn || ''
  const normalizedCdn = cdnHost && cdnHost[cdnHost.length - 1] === '/' ? cdnHost : `${cdnHost}/`
  return src[0] === '/' ? `${normalizedCdn}${src.slice(1)}` : `${normalizedCdn}${src}`
}

function appendImageMogr2Params (src, suffix) {
  const hashIndex = src.indexOf('#')
  const pathAndQuery = hashIndex > -1 ? src.slice(0, hashIndex) : src
  const hash = hashIndex > -1 ? src.slice(hashIndex) : ''
  const separator = pathAndQuery.indexOf('?') > -1 ? '&' : '?'
  return `${pathAndQuery}${separator}imageMogr2${suffix}${hash}`
}

// imageMogr2 https://developer.qiniu.com/dora/8255/the-zoom
// /thumbnail/<Width>x    指定目标图片宽度，高度等比缩放，Width取值范围1-9999。
// /crop/<Width>x<Height> 同时指定目标图片宽高。取值范围为0-10000。
// /quality/<Quality>     新图的图片质量，取值范围是[1, 100]

export function formatByImageMogr2 (src, { thumbnail, crop, quality, format }) {
  let suffix = '/auto-orient'
  if (thumbnail) {
    const { w, h } = thumbnail
    suffix += `/thumbnail/!${w || ''}x${h || ''}${w && h ? 'r' : ''}`
  }
  if (crop) {
    const { w, h } = crop
    suffix += `/gravity/center/crop/${w || ''}x${h || ''}`
  }
  if (quality) {
    suffix += `/quality/${quality}`
  }
  if (format) {
    suffix += `/format/${format}`
  }
  suffix += `/ignore-error/1`
  return appendImageMogr2Params(src, suffix)
}

/**
* 方法说明
* @method
* @param {object} params 图片处理参数
* 例：
* {
*   thumbnail: { w: 528, h: 288 },
*   crop: { w: 528, h: 288 },
*   quality: 90
* }
* 或：
* {
*   w: 528,
*   h: 288
* }
* 当同时存在时，w\h 会覆盖 thumbnail 和 crop
* @return {string} 处理后的图片链接
*/

export function formatImage (isSupportWebp, cdn, src, params) {
  if (!src) return ''
  const imageParams = Object.assign({}, params)
  if (imageParams.w || imageParams.h) {
    imageParams.thumbnail = { w: imageParams.w, h: imageParams.h }
    imageParams.crop = { w: imageParams.w, h: imageParams.h }
  }
  src = normalizeImageSrc(cdn, src)
  let extension = getExtension(src)
  const isWebp = extension === 'webp'
  const isGif = extension === 'gif'
  if (isGif) return src
  if (!extension) {
    return formatByImageMogr2(src, {
      quality: 90
    })
  }
  let enableFormatConversion = true
  if (imageParams.enableFormatConversion === false) {
    enableFormatConversion = false
  }
  if (!enableFormatConversion) return formatByImageMogr2(src, imageParams)
  if (isWebp && isSupportWebp) {
    return formatByImageMogr2(src, imageParams)
  } else if (isWebp && !isSupportWebp) {
    return formatByImageMogr2(src, Object.assign({}, imageParams, { format: 'jpg' }))
  } else if (isSupportWebp) {
    return formatByImageMogr2(src, Object.assign({}, imageParams, { format: 'webp' }))
  } else {
    return formatByImageMogr2(src, imageParams)
  }
}
